import { parseKst } from '../../common/utils';

const DATE_TIME_FORMAT = 'MM월 DD일(dddd) HH:mm';
const TIME_FORMAT = 'HH:mm';

export interface MaintenanceWindow {
  start: string;
  end: string;
}

export const formatMaintenanceWindow = (window: MaintenanceWindow): string | null => {
  const start = parseKst(window.start).locale('ko');
  const end = parseKst(window.end).locale('ko');
  if (!start.isValid() || !end.isValid()) return null;

  const sameDay = start.isSame(end, 'day');
  const startLabel = start.format(DATE_TIME_FORMAT);
  const endLabel = sameDay ? end.format(TIME_FORMAT) : end.format(DATE_TIME_FORMAT);
  return `${startLabel} ~ ${endLabel}`;
};
